import { useEffect, useState } from 'react';
// import { getLeapFromWindow } from '@/utils/getLeapFromWindow.js';
import { ErrorBoundary } from '@/components';
import { getKeplrFromWindow } from '@/utils/getKeplrFromWindow';
import {
  useCosmosControllerAuthenticateMutation,
  useCosmosControllerConnectWalletMutation,
  useLazyCosmosControllerGetCosmosLoginMessageQuery,
} from '@/store/services/MidleNestApi.service';
import { useAuthenticated } from '@/hooks/useAuthenticated.hook';
import { useModal, useProfile } from '@/hooks';
import { useNavigate } from 'react-router-dom';

export default function KeplrConnectionView() {
  const [getMessage] = useLazyCosmosControllerGetCosmosLoginMessageQuery();
  const [walletLogin] = useCosmosControllerAuthenticateMutation();
  const [walletConnect] = useCosmosControllerConnectWalletMutation();

  const { reloadProfile } = useProfile();
  const navigate = useNavigate();
  const { hideModal } = useModal();

  const { isAuthenticated } = useAuthenticated();

  const [address, setAddress] = useState('');
  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const keplr = await getKeplrFromWindow();
    if (keplr) {
      try {
        // evmos_9001-2, cosmoshub-4, nibiru-testnet-1, cataclysm-1
        const chainId = 'cataclysm-1';
        await keplr.enable(chainId);
      } catch (e) {
        if (e instanceof Error) {
          console.log(e.message);
        }
      }
    }
  };

  // const signEthereumKeplr = async (signer: string, message: string) => {
  //   try {
  //     console.log({ signer, message });
  //     const signature = await window.keplr?.signEthereum(
  //       'cataclysm-1',
  //       signer,
  //       message,
  //       EthSignType.MESSAGE,
  //     );
  //     console.log({ signature });
  //   } catch (e: any) {
  //     console.log(e.message);
  //   }
  // };

  // const signAminoKeplr = async (signer: string, message: string) => {
  //   const signature = await window.keplr?.signAmino('cataclysm-1', signer, {
  //     chain_id: '',
  //     account_number: '0',
  //     sequence: '0',
  //     fee: {
  //       gas: '0',
  //       amount: [],
  //     },
  //     msgs: [
  //       {
  //         type: 'sign/MsgSignData',
  //         value: {
  //           signer: signer,
  //           data: btoa(message),
  //         },
  //       },
  //     ],
  //     memo: '',
  //   });
  //   console.log({ signature });
  //   return {
  //     signature: signature?.signature.signature,
  //     publicKey: signature?.signature.pub_key.value,
  //   };
  // };

  const signArbitraryKeplr = async (signer: string, message: string) => {
    const signature = await (window as any).keplr?.signArbitrary('cataclysm-1', signer, message);
    // console.log(signature?.signature, signature?.pub_key.value);
    return {
      signature: signature?.signature,
      publicKey: signature?.pub_key.value,
    };
  };

  const handleSignMessage = async (signer: string, message: string) => {
    try {
      return await signArbitraryKeplr(signer, message);
    } catch (error) {
      console.log({ error });
      return '';
    }
  };

  const connectByKepler = async () => {
    const key = await (window as any).keplr?.getKey('cataclysm-1');
    if (key) {
      setAddress(key.bech32Address);

      getMessage(key.bech32Address.toLowerCase())
        .unwrap()
        .then(async (nonce) => {
          const signature = await handleSignMessage(key.bech32Address, nonce.message);
          if (!signature || !signature.publicKey || !signature.signature) return; // TODO: display error message
          if (isAuthenticated) {
            walletConnect({
              accountAddress: key.bech32Address,
              message: nonce.message,
              signature: signature.signature,
              signaturePublicKey: signature.publicKey,
            })
              .unwrap()
              .then((res) => {
                gtag('event', 'connect-wallet');
                reloadProfile();
                hideModal();
                return navigate('/', {});
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            walletLogin({
              accountAddress: key.bech32Address,
              message: nonce.message,
              signature: signature.signature,
              signaturePublicKey: signature.publicKey,
            })
              .unwrap()
              .then((res) => {
                gtag('event', 'auth-wallet');
                reloadProfile();
                hideModal();
                return navigate('/', {});
              })
              .catch((e) => {
                console.log(e);
              });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  return (
    <div className='root-container'>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '16px',
        }}
      >
        <img src='/keplr-logo.png' style={{ maxWidth: '200px' }} alt='keplr-logo' />
      </div>

      <div>
        <div className='flex items-center justify-center'>
          <div className='text-gray-400'>
            <div>Address: {address}</div>

            <div>
              <button className='bg-gray-900 text-red-400' onClick={connectByKepler}>
                Connect Wallet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Component.displayName = 'NibiruConnection';
export { ErrorBoundary };
